export default __webpack_public_path__ + "static/media/gasket.1e8bd3f6.png";